import { render, staticRenderFns } from "./Invoice.vue?vue&type=template&id=deca979a&scoped=true"
import script from "./Invoice.vue?vue&type=script&lang=js"
export * from "./Invoice.vue?vue&type=script&lang=js"
import style0 from "./Invoice.vue?vue&type=style&index=0&id=deca979a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deca979a",
  null
  
)

export default component.exports